import MxRushCounter, {
  MxRushCounterProps
} from "@rf-l1/form/rush-field/MxRushCounter";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
type omit = Omit<MxRushCounterProps, "name" | "onChange" | "onBlur">;

export type MxFormRushCounterFieldProps = omit;

const MxFormRushCounterField = (props: MxFormRushCounterFieldProps) => {
  const { id, name, onChange, onBlur, value, invalid } =
    useMxFieldControllerContext();

  return (
    <MxRushCounter
      {...props}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      id={id}
    />
  );
};

export default MxFormRushCounterField;
